// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__19Bz7","inner":"style_inner__2NgBU","bottom":"style_bottom__3SwSE","copyright":"style_copyright__1WG5E"};